import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Parking.svg",
  "use": "Parking.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Parking.svg\"><path d=\"M32,56A24,24,0,1,1,56,32,24,24,0,0,1,32,56Zm0-44A20,20,0,1,0,52,32,20,20,0,0,0,32,12ZM28,38v5a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1V21a1,1,0,0,1,1-1H35a9,9,0,1,1,0,18Zm7-12H28v6h7a3,3,0,1,0,0-6Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol